import axios from '../utils/axios';

export const listAll = () => {
  return axios.get(`groups`);
}
